import { render, staticRenderFns } from "./ProtocolloRubricaListComponent.vue?vue&type=template&id=85ae8bf0"
import script from "./ProtocolloRubricaListComponent.vue?vue&type=script&lang=js"
export * from "./ProtocolloRubricaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports